import { render, staticRenderFns } from "./employee-history-list.component.vue?vue&type=template&id=4546d4d2&scoped=true&"
import script from "./employee-history-list.component.vue?vue&type=script&lang=ts&"
export * from "./employee-history-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-history-list.component.vue?vue&type=style&index=0&id=4546d4d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546d4d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
